"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalDustStormRebalanced = void 0;
var GlobalEventName_1 = require("./GlobalEventName");
var PartyName_1 = require("../parties/PartyName");
var Resources_1 = require("../../Resources");
var Tags_1 = require("../../cards/Tags");
var GlobalDustStormRebalanced = (function () {
    function GlobalDustStormRebalanced() {
        this.name = GlobalEventName_1.GlobalEventName.GLOBAL_DUST_STORM_REBALANCED;
        this.description = 'Lose up to 5 heat. Lose 2 M€ for each Building tag (max 5, then reduced by influence).';
        this.revealedDelegate = PartyName_1.PartyName.KELVINISTS;
        this.currentDelegate = PartyName_1.PartyName.GREENS;
    }
    GlobalDustStormRebalanced.prototype.resolve = function (game, turmoil) {
        var _this = this;
        game.getPlayers().forEach(function (player) {
            if (player.heat > 0) {
                player.deductResource(Resources_1.Resources.HEAT, Math.min(player.heat, 5), { log: true, from: _this.name });
            }
            var maxedSteelTags = Math.min(5, player.getTagCount(Tags_1.Tags.BUILDING, false, false));
            player.deductResource(Resources_1.Resources.MEGACREDITS, 2 * Math.max(0, maxedSteelTags - turmoil.getPlayerInfluence(player)), { log: true, from: _this.name });
        });
    };
    return GlobalDustStormRebalanced;
}());
exports.GlobalDustStormRebalanced = GlobalDustStormRebalanced;
//# sourceMappingURL=GlobalDustStormRebalanced.js.map